import React, {useMemo} from 'react'
import parse from 'html-react-parser'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'

import {
    Box,
    Stack,
    Text,
    Link,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import RecentSearches from '@salesforce/retail-react-app/app/components/search/partials/recent-searches'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import Suggestions from './suggestions'
import {searchUrlBuilder} from '@salesforce/retail-react-app/app/utils/url'

const SearchSuggestions = ({
    recentSearches = [],
    searchSuggestions = {},
    closeAndNavigate,
    noResultObject = {},
    onSubmitSearch
}) => {
    const styles = useMultiStyleConfig('Suggestions')
    const navigate = useNavigation()

    const {popularSuggestions, hasSuggestions} = useMemo(() => {
        const popularSuggestions = searchSuggestions?.popularSuggestions || []

        const hasSuggestions =
            searchSuggestions?.categorySuggestions?.length > 0 ||
            searchSuggestions?.productSuggestions?.length > 0

        return {popularSuggestions, hasSuggestions}
    }, [
        searchSuggestions?.popularSuggestions,
        searchSuggestions?.categorySuggestions,
        searchSuggestions?.productSuggestions
    ])

    const handleSuggestionClick = (value) => {
        navigate(searchUrlBuilder(value))
    }

    return (
        <Stack spacing={0}>
            {hasSuggestions ? (
                <Suggestions
                    closeAndNavigate={closeAndNavigate}
                    suggestions={searchSuggestions}
                    onSubmitSearch={onSubmitSearch}
                />
            ) : noResultObject.showNoResultMessage ? (
                <Box {...styles.textStyle} p={4} bg="#23252b" color="white">
                    {popularSuggestions.length > 0 && (
                        <>
                            <Text {...styles.categoryTextStyle}>
                                <FormattedMessage
                                    defaultMessage="POPULAR SEARCHES"
                                    id="search_suggestions.popular"
                                />
                            </Text>
                            {popularSuggestions.map(({value}, idx) => (
                                <Link
                                    key={idx}
                                    tabIndex={0}
                                    role="option"
                                    onMouseDown={() => handleSuggestionClick(value)}
                                    fontSize="md"
                                    display="block"
                                    variant="menu-link"
                                    color="textColorInvert"
                                    fontWeight={'bold'}
                                    pb={4}
                                >
                                    {parse(value)}
                                </Link>
                            ))}
                        </>
                    )}
                    <Text>
                        <FormattedMessage
                            defaultMessage="No results found for '{searchQuery}'. Please try another search."
                            id="search_suggestions.no_result"
                            values={{searchQuery: noResultObject.searchQuery || ''}}
                        />
                    </Text>
                </Box>
            ) : (
                <RecentSearches
                    recentSearches={recentSearches}
                    closeAndNavigate={closeAndNavigate}
                />
            )}
        </Stack>
    )
}

SearchSuggestions.propTypes = {
    recentSearches: PropTypes.array,
    searchSuggestions: PropTypes.object,
    closeAndNavigate: PropTypes.func,
    onSubmitSearch: PropTypes.func,
    noResultObject: PropTypes.object
}

export default SearchSuggestions
